/* Variant selection without a framework. Radios post straight to the cart when
   JS is unavailable, so the form degrades to a working add-to-cart. */
(function () {
  'use strict';

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-form]').forEach(function (form) {
      var data = form.querySelector('[data-variants]');
      if (!data) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-live-price]');
      var configEl = document.querySelector('[data-live-config]');
      var submit = form.querySelector('[data-add-button]');
      var barPrice = document.querySelector('[data-bar-price]');

      function selected() {
        return Array.prototype.map.call(
          form.querySelectorAll('[data-option-index]'),
          function (group) {
            var checked = group.querySelector('input[type="radio"]:checked');
            return checked ? checked.value : null;
          }
        );
      }

      function match(options) {
        return variants.find(function (v) {
          return options.every(function (opt, i) { return opt === null || v.options[i] === opt; });
        });
      }

      /* A colour has its own photograph, so picking one moves the gallery to it.
         Clicking the matching thumb keeps one code path for every switch (and
         keeps the thumb marked current); a photo past the eight thumbs shown is
         set straight onto the main image. */
      function showVariantMedia(variant) {
        var gal = document.querySelector('[data-gallery]');
        if (!gal || !variant.media_id) return;
        var thumb = gal.querySelector('[data-media-id="' + variant.media_id + '"]');
        if (thumb) { thumb.click(); return; }
        if (window.MeridianGallery && variant.media_src) {
          window.MeridianGallery.show(gal, variant.media_src, '', variant.media_alt);
        }
      }

      function update(moveGallery) {
        var options = selected();
        var variant = match(options);
        if (!variant) return;
        if (moveGallery) showVariantMedia(variant);

        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          var now = priceEl.querySelector('.price__now');
          if (now && variant.price_formatted) now.innerHTML = variant.price_formatted;
        }
        /* Shopify's instalment component works from the variant on its own
           attribute, so it has to follow the choice: a product whose variants
           sit either side of the provider's minimum would otherwise quote the
           first variant's terms for all of them. */
        var terms = document.querySelector('[data-payment-terms] shopify-payment-terms');
        if (terms) terms.setAttribute('variant-id', variant.id);

        var totalEl = document.querySelector('[data-live-total]');
        if (totalEl && variant.price_formatted) totalEl.innerHTML = variant.price_formatted;
        if (barPrice && variant.price_formatted) barPrice.innerHTML = variant.price_formatted;
        if (configEl) configEl.textContent = variant.options.join(' · ');

        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available
            ? submit.dataset.labelAvailable
            : submit.dataset.labelSoldOut;
        }

        // Keep the URL shareable without adding a history entry per click.
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) update(true);
      });
      /* The first pass only syncs price and id: the page already rendered the
         selected variant's photo, and moving the gallery here would throw away
         the responsive srcset Liquid put on it. */
      update(false);
    });
  }

  /* Quantity stepper: works on single-variant products too, so it is delegated. */
  function syncQty(input) {
    var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 9999;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = Math.min(max, Math.max(min, v));
    input.value = v;
    var field = input.closest('[data-qty-field]');
    field.querySelector('[data-qty-delta="-1"]').disabled = v <= min;
    field.querySelector('[data-qty-delta="1"]').disabled = v >= max;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty-delta]');
    if (!btn) return;
    var input = btn.closest('[data-qty-field]').querySelector('input');
    input.value = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyDelta, 10);
    syncQty(input);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-qty-field] input')) syncQty(e.target);
  });
  function initQty(scope) {
    (scope || document).querySelectorAll('[data-qty-field] input').forEach(syncQty);
  }
  initQty();
  document.addEventListener('shopify:section:load', function (e) { initQty(e.target); });

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
